<template>
  <q-table
    class="neg-tabela"
    row-key="id"
    dense
    flat
    :rows="negociosOportunidades"
    :columns="colunas"
    :loading="negociosCarregando"
    v-model:pagination="paginacao"
    :rows-per-page-options="[25, 50, 100]"
    no-data-label="Nenhuma oportunidade encontrada"
    loading-label="Carregando oportunidades"
    rows-per-page-label="Por página"
    @request="pedirPagina"
    @row-click="(evento, linha) => $emit('abrir', linha)"
  >
    <template v-slot:body-cell-linha="props">
      <q-td :props="props">
        <span :title="resumoDeLinhas(props.row).titulo">{{ resumoDeLinhas(props.row).texto }}</span>
      </q-td>
    </template>

    <template v-slot:body-cell-etapa="props">
      <q-td :props="props">
        <span class="neg-badge" :style="estiloDaEtapa(props.row.etapa)">
          {{ props.row.etapa ? props.row.etapa.nome : "" }}
        </span>
      </q-td>
    </template>

    <template v-slot:body-cell-data_alerta="props">
      <q-td :props="props">
        <span :class="'neg-alerta--' + props.row.alerta_nivel">
          {{ dataParaTela(props.row.data_alerta) || "—" }}
        </span>
        <div v-if="rotuloDoAlerta(props.row.data_alerta)" class="neg-sub">
          {{ rotuloDoAlerta(props.row.data_alerta) }}
        </div>
      </q-td>
    </template>

    <template v-slot:body-cell-comissao_prevista="props">
      <q-td :props="props" class="text-right">
        <span v-if="comissaoVisivel(props.row)">
          {{ formatarMoeda(props.row.comissao_prevista) }}
        </span>
        <span v-else class="neg-oculto">
          ••••
          <q-tooltip>Sem permissão para ver a comissão de outro operador</q-tooltip>
        </span>
      </q-td>
    </template>
  </q-table>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-lista",

  emits: ["abrir", "ordenar"],
  mixins: [negociosMixin],
  data() {
    return {
      paginacao: {
        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: false,
        rowsNumber: 0
      }
    };
  },
  computed: {
    ...mapGetters(["negociosOportunidades", "negociosCarregando", "negociosPaging"]),
    colunas() {
      return [
        { name: "codigo", label: "Código", field: "codigo", align: "left", sortable: true },
        {
          name: "cliente",
          label: "Cliente",
          align: "left",
          sortable: true,
          field: linha => (linha.cliente ? linha.cliente.nome : "")
        },
        {
          name: "linha",
          label: "Linha",
          align: "left",
          sortable: true,
          field: linha => (linha.linha ? linha.linha.nome : ""),
          format: (valor, linha) => this.resumoDeLinhas(linha).texto
        },
        { name: "etapa", label: "Etapa", field: "etapa_id", align: "left", sortable: true },
        { name: "operador", label: "Operador", field: "operador", align: "left", sortable: true },
        {
          name: "valor_solicitado",
          label: "Solicitado",
          field: "valor_solicitado",
          align: "right",
          sortable: true,
          format: valor => this.formatarMoeda(valor)
        },
        {
          name: "valor_contratado",
          label: "Contratado",
          field: "valor_contratado",
          align: "right",
          sortable: true,
          format: valor => (valor === null ? "—" : this.formatarMoeda(valor))
        },
        {
          name: "comissao_prevista",
          label: "Comissão prevista",
          field: "comissao_prevista",
          align: "right"
        },
        {
          name: "data_alerta",
          label: "Retorno",
          field: "data_alerta",
          align: "left",
          sortable: true
        },
        {
          name: "etapa_desde",
          label: "Na etapa",
          field: "dias_na_etapa",
          align: "right",
          sortable: true,
          format: dias => this.rotuloDeDiasNaEtapa(dias)
        }
      ];
    }
  },
  watch: {
    negociosPaging: {
      immediate: true,
      handler(paging) {
        this.paginacao = {
          ...this.paginacao,
          page: paging.page || 1,
          rowsPerPage: paging.limit || 25,
          rowsNumber: paging.count || 0
        };
      }
    }
  },
  methods: {
    estiloDaEtapa(etapa) {
      const cor = etapa && etapa.cor ? etapa.cor : "#2741b5";

      return { background: cor, color: cor === "#f9b500" ? "#1b1b21" : "#ffffff" };
    },
    pedirPagina(pedido) {
      const { page, rowsPerPage, sortBy, descending } = pedido.pagination;

      this.$emit("ordenar", {
        page,
        limit: rowsPerPage,
        sort: sortBy,
        direction: descending ? "desc" : "asc"
      });
    }
  }
};
</script>
